import { z } from 'zod';
import { LiliPlanType } from '@lili/lili-frontend-common';
import { fallback } from '@tanstack/router-zod-adapter';

export const planSelectionQueryParamsSchema = z.object({
  initialPlan: fallback(z.nativeEnum(LiliPlanType), LiliPlanType.SMART),
});
